import React from 'react';
const kennitala = require('kennitala')
import { getPaymentKeyText, Spinner } from '../../utils'
import { gettext } from '../../locale'
import moment from 'moment'

import ContractLine from '../contract-line'

import 'chartjs-plugin-colorschemes';

class OfferKsp extends React.Component {

    constructor(props) {
        super(props)
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    render() {

        let customer = this.props.customer
        let offer = this.props.offer[this.props.offerType]
        let parameters = offer.parameters
        let keyFigures = offer.keyFigures

        if (offer.isFetching || this.props.customer.isFetching) {
            return <Spinner />
        }

        if (offer.error) {
            return (<>
                { offer.errorMessage }
            </>)
        }

        let paymentTextKey = getPaymentKeyText(this.props.infoCollection["KSPpaymentfrequency"])

        return (<>
                <div className="row justify-content-center xs-pt-50 offer">
                    <div className="col-12">
                        <h3>Persónuupplýsingar</h3>
                        {customer.Customer.Name}<br />

                        Dagsetning tilboðs {moment.utc().format("D.M.YYYY")}

                    </div>
                </div>

                <div className="row justify-content-center xs-pt-50 offer">
                    <div className="col-12">
                        <h3>Forsendur útreikninga</h3>
                        <table className="table table-hover table-sm table-offer table-responsive-sm">
                            <tbody>
                                <tr>
                                    <td>
                                        <strong>{gettext("startDate")}</strong> ({gettext("startDate", "de")})
                                    </td>
                                    <td className="text-right nowrap">
                                        {parameters.start.format("D.M.YYYY")}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <strong>{gettext("contractLength")}</strong> ({gettext("contractLength", "de")})
                                    </td>
                                    <td className="text-right nowrap">
                                        {parameters.length} ár
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>

                <div className="row justify-content-center xs-pt-50 offer">
                    <div className="col-12">

                        <h3>{gettext("ksp.amountHeading")} ({gettext("ksp.amountHeading", "de")})</h3>
                        <table className="table table-hover table-sm table-offer table-responsive-sm">
                            <tbody>
                                <ContractLine name="ksp.monthly_payment" value={keyFigures["GarantierteRente"]} currencyExchange={this.props.currencyExchange} />
                                <tr><td>{gettext('ksp.monthly_payment_subtext')} fyrir {keyFigures['contractEnds'].format("D.M.YYYY")}<br/>({gettext('ksp.monthly_payment_subtext', 'de')})</td><td></td></tr>
                                <ContractLine name="ksp.onetime" value={keyFigures["GesamtKapitalSchwereErkrankung"]} currencyExchange={this.props.currencyExchange} />
                                <tr><td>Fyrir {keyFigures['contractEnds'].format("D.M.YYYY")}</td><td></td></tr>
                                

                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="row justify-content-center xs-pt-50 offer">
                    <div className="col-12">
                        <h3>{gettext("TotalHauptprodukt")} ({gettext("TotalHauptprodukt", "de")})</h3>
                        <table className="table table-hover table-sm table-offer table-responsive-sm">
                            <tbody>
                                <ContractLine name={paymentTextKey} value={keyFigures["Hauptprodukt"]} currencyExchange={this.props.currencyExchange} eurDecimals={2} />
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 text-center">
                        <img src={window.images.kspInfo} style={{maxWidth: '100%'}} />
                    </div>
                </div>

            </>)

    }
}

export default OfferKsp
